<template>
  <div class="pkg-page">
    <header class="pkg-page__hero">
      <div class="pkg-page__hero-text">
        <h1 class="pkg-page__title">Багц</h1>
        <p class="pkg-page__subtitle">Багц үүсгэж, жагсаалтаас удирдана уу</p>
      </div>
      <el-button
        type="success"
        size="medium"
        icon="el-icon-plus"
        class="pkg-page__create-btn"
        @click="openPackageDialog"
      >
        Багц үүсгэх
      </el-button>
    </header>

    <div class="pkg-page__list">
      <DeliveryComponent
        ref="deliveryComponent"
        :progressCode="transacProgressCode"
        @refreshDeliveryList="getPackageList"
      />
    </div>

    <el-dialog
      :visible.sync="addPackageDialog"
      :before-close="handleClose"
      custom-class="pkg-dialog"
      width="92%"
      append-to-body
      top="12vh"
    >
      <template slot="title">
        <div class="pkg-dialog__head">
          <span class="pkg-dialog__kicker">Шинэ</span>
          <span class="pkg-dialog__title">Багц үүсгэх</span>
        </div>
      </template>
      <el-form label-position="top" class="pkg-dialog__form" @submit.native.prevent>
        <el-form-item label="Багцын код">
          <el-input
            v-model="code"
            placeholder="Код оруулна уу"
            clearable
            maxlength="40"
            @keyup.enter.native="createPackage"
          />
        </el-form-item>
        <el-button
          class="pkg-dialog__btn"
          type="success"
          :loading="saving"
          @click="createPackage"
        >
          Хадгалах
        </el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import services from '@/helpers/services'
import DeliveryComponent from '@/components/DeliveryComponent.vue'

export default {
  name: 'PackagePage',
  components: {
    DeliveryComponent
  },
  data () {
    return {
      packageList: [],
      addPackageDialog: false,
      code: null,
      transacProgressCode: '210',
      saving: false
    }
  },
  created () {
    this.getPackageList()
  },
  methods: {
    async getPackageList () {
      try {
        this.$root.fullscreenLoading = true
        const payload = { progress_code: '210' }
        const response = await services.getDeliveryList(payload)
        if (response.type === 'success') {
          this.packageList = response.data
        }
        const child = this.$refs.deliveryComponent
        if (child && typeof child.getDeliveryList === 'function') {
          await child.getDeliveryList()
        }
      } catch (error) {
        console.error('Алдаа:', error)
        this.$notify({
          title: 'Алдаа',
          message: error && error.message ? error.message : String(error),
          type: 'error'
        })
      } finally {
        this.$root.fullscreenLoading = false
      }
    },
    async createPackage () {
      if (!this.code || !String(this.code).trim()) {
        this.$notify({
          title: 'Анхааруулга',
          message: 'Багцын код оруулна уу',
          type: 'warning'
        })
        return
      }
      try {
        this.saving = true
        this.$root.fullscreenLoading = true
        const payload = { code: String(this.code).trim(), progress_code: '210' }
        const response = await services.createPackage(payload)
        if (response.type === 'success') {
          this.code = null
          this.handleClose()
          await this.getPackageList()
          this.$notify({
            title: 'Амжилттай',
            message: 'Багц амжилттай үүслээ',
            type: 'success'
          })
        }
      } catch (error) {
        console.error('Алдаа:', error)
        this.$notify({
          title: 'Алдаа',
          message: error && error.message ? error.message : String(error),
          type: 'error'
        })
      } finally {
        this.saving = false
        this.$root.fullscreenLoading = false
      }
    },
    openPackageDialog () {
      this.addPackageDialog = true
    },
    handleClose () {
      this.addPackageDialog = false
    }
  }
}
</script>

<style scoped>
.pkg-page {
  max-width: 640px;
  margin: 0 auto;
  padding: 16px 14px 28px;
  background: linear-gradient(180deg, #f1f5f9 0%, #f8fafc 45%, #fff 100%);
  min-height: 100%;
}

.pkg-page__hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.pkg-page__title {
  margin: 0;
  font-size: 1.45rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.pkg-page__subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #64748b;
}

.pkg-page__create-btn {
  flex-shrink: 0;
  border-radius: 12px !important;
}

.pkg-page__list {
  margin-top: 4px;
}

.pkg-page__list >>> .infinite-scroll-table {
  background: transparent;
  box-shadow: none;
  padding: 0;
}
</style>

<style>
.pkg-dialog.el-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  max-width: 400px;
}

.pkg-dialog .el-dialog__header {
  padding: 16px 18px 12px;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 50%, #e8eef5 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.3);
}

.pkg-dialog .el-dialog__body {
  padding: 16px 18px 20px;
  background: #f8fafc;
}

.pkg-dialog__head {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-right: 28px;
}

.pkg-dialog__kicker {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #047857;
  font-weight: 600;
}

.pkg-dialog__title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #0f172a;
}

.pkg-dialog__form .el-form-item__label {
  color: #475569 !important;
  font-weight: 500;
  padding-bottom: 4px !important;
}

.pkg-dialog__form .el-input__inner {
  border-radius: 10px !important;
}

.pkg-dialog__btn {
  width: 100%;
  margin-top: 8px;
  border-radius: 12px !important;
  font-weight: 600;
}
</style>
